import { useTranslation } from "react-i18next";
import { SettingsSubHeader } from "../SettingsSubHeader";
import { PracticeProfilesEditor } from "../../../practice/PracticeProfilesEditor";
import { closeSettings } from "../../../../domains/app/stores/settingsSheetStore";
import KeyboardAvoidingView from "../../../layout/KeyboardAvoidingView";
import { useKeyboardManaged } from "../../../../hooks/use-keyboard-managed";

/**
 * Settings entry for the Practice Profiles a practitioner holds — what keeps
 * their rail theirs as their practice shifts (practice-profiles ticket 08).
 *
 * Saving CLOSES the drawer rather than staying put: what the save changed is the
 * rail underneath, so a sheet left open covers the only evidence it worked. The
 * chevron remains the way out of a visit that changed nothing.
 */
export function PracticeView(): React.JSX.Element {
  const { t } = useTranslation();
  // The editor's search field sits in the bottom band of the sheet.
  useKeyboardManaged();

  return (
    <KeyboardAvoidingView
      behavior="padding"
      // The keyboard also covers what BottomPanel keeps under this view (its
      // 20px band and the safe-area inset). 8px of that band is kept as air.
      offset="calc(-12px - env(safe-area-inset-bottom))"
      className="flex h-full flex-col"
    >
      <SettingsSubHeader title={t("My practice")} />
      {/* No campaign guess here: somebody who opened their own settings came to
          state something, and meeting a guess is a different act from meeting
          one on a screen that exists to ask (practice-profiles ticket 09). */}
      <PracticeProfilesEditor
        seedFromInference={false}
        surface="sheet"
        onSaved={closeSettings}
      />
    </KeyboardAvoidingView>
  );
}
